var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakeholderVariance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.526,
    height: 25.573,
    viewBox: "0 0 27.526 25.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 27.526,
    height: 25.573,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M24.506,14.81a5.734,5.734,0,0,0-2.542-.674l-.156,0h0a5.678,5.678,0,0,0-4.4,2.068l-2.828-1.633V11.4A5.718,5.718,0,0,0,17.6,1.333,5.718,5.718,0,1,0,13.286,11.4v3.169L10.2,16.352a5.7,5.7,0,1,0,.675,1.108l3.06-1.766,2.764,1.6a5.718,5.718,0,1,0,7.808-2.479m-2.7,7.112h.01a4.39,4.39,0,0,1,3,1.17,4.421,4.421,0,0,1-6.011,0,4.4,4.4,0,0,1,3.006-1.17m-2.392-5.791a4.41,4.41,0,0,1,2.389-.7h.007a4.418,4.418,0,0,1,3.814,6.648,5.7,5.7,0,0,0-3.817-1.452H21.8a5.691,5.691,0,0,0-3.808,1.452,4.424,4.424,0,0,1,1.425-5.947M13.934,6.494h-.011a5.689,5.689,0,0,0-3.807,1.452A4.418,4.418,0,0,1,13.93,1.3h.007a4.418,4.418,0,0,1,3.814,6.648,5.7,5.7,0,0,0-3.817-1.452M16.94,8.96a4.375,4.375,0,0,1-3,1.181h0a4.377,4.377,0,0,1-3-1.181,4.4,4.4,0,0,1,3.007-1.17h.009a4.394,4.394,0,0,1,3,1.17M9.5,22.078a5.7,5.7,0,0,0-3.817-1.452h-.01a5.689,5.689,0,0,0-3.808,1.452,4.424,4.424,0,0,1,3.809-6.655,4.474,4.474,0,0,1,.949.1A4.422,4.422,0,0,1,9.5,22.078m-.812,1.014a4.42,4.42,0,0,1-6.011,0,4.394,4.394,0,0,1,3.005-1.17h.01a4.392,4.392,0,0,1,3,1.17",
    transform: "translate(0 0)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M40.336,7.4a1.987,1.987,0,1,0,1.987,1.987A1.989,1.989,0,0,0,40.336,7.4m0,2.677h0a.691.691,0,0,1-.69-.691.69.69,0,1,1,.691.691",
    transform: "translate(-26.401 -5.092)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M65.607,56.727a1.987,1.987,0,0,0,0-3.974h0a1.987,1.987,0,1,0,0,3.974m.69-1.987a.69.69,0,1,1-.69-.69.69.69,0,0,1,.69.69",
    transform: "translate(-43.799 -36.318)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M13.852,52.753h0a1.987,1.987,0,0,0,0,3.974h0a1.987,1.987,0,0,0,0-3.974m-.69,1.987a.69.69,0,1,1,.69.69.691.691,0,0,1-.69-.69",
    transform: "translate(-8.169 -36.318)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholderVariance);
export default __webpack_public_path__ + "static/media/stakeholder_variance.a26efcadac4a22bbc45bd83887e7a439.svg";
export { ForwardRef as ReactComponent };